<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      align-center
      justify-center
    >
      <v-flex>
        <div>
          <!-- <h1>Login</h1> -->
          <!-- <input
      v-model="input.username"
      type="text"
      name="username"
      placeholder="Username"
    > -->
          <input
            ref="password"
            v-model="input.password"
            type="password"
            name="password"
            placeholder="Password"
            @keyup.enter="login()"
          >
    &nbsp;
          <button
            type="button"
            class="button"
            @click="login()"
          >
            Login
            <!-- <img
        :src="publicPath('/img/login.png')"
        alt="Login"
      > -->
          </button>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import CustomInput from './CustomInput.vue'

export default {
  name: 'Login',
  // components: { CustomInput },
  data () {
    return {
      input: {
        username: 'guest',
        password: '',
      },
    }
  },
  mounted () {
    this.focusInput()
  },
  methods: {
    focusInput () {
      // this.$refs.password.focus()
      // this.$nextTick(() => this.$refs.password.focus())
      setTimeout(() => {
        this.$refs.password.focus()
      }, 1000)
    },
    login () {
      if (this.input.username === 'guest' && this.input.password === 'pass') {
        this.$store.commit('setAuthentication', true)
        this.$router.replace({ name: 'secure' })
      } else
      // eslint-disable-next-line no-console
        console.log('The username and / or password is incorrect')
    },
  },
}
</script>

<style scoped>
.button {
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 14px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 17px;
}
input{
  border: 20px solid #0190fd;
  padding: 7px 5px 7px 5px;
  height: 16px;
  width: 150px;
  margin: 0;
  /* float: left; */
  text-align: center;
  text-decoration: none;
}
div{
    text-align: center;
}
</style>
